var map = {
	"./dstv.png": "0bf9",
	"./ekedc.png": "37b1",
	"./ghana-flag.png": "1949",
	"./gotv.png": "4935",
	"./ibedc.png": "1c88",
	"./ikeja.png": "590b",
	"./ipnx.png": "bac3",
	"./smile.png": "baed",
	"./startimes.png": "3a80",
	"./swift.png": "6f76",
	"./waec.png": "0f12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";